import { cloneDeep } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { DEFAULT_DOCUMENT_TEMPLATES_INVOICE_PAYLOAD, buttonModes, services, sizes } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import invoiceDialog from '@/components/services/notifications/dialog/balance/limit/invoice/dialog'
import panel from '@/components/services/notifications/dialog/balance/limit/panel'

const path = 'notifications.events.balance.limit'

function renderEmptyState(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${services.notifications}.hints.${path}.empty`)
      }
    }
  )
}

function renderPanel(h, value, index) {
  const key = [ this.path, 'panel', index ].join(':')

  return h(
    panel,
    {
      props: {
        value,
        currency: this.currency,
        path: this.path,
        index
      },
      key,
      on: {
        input: event => {
          value = event
        },
        remove: () => {
          this.remove(index)
        },
        dialog: event => {
          this.proxy[index].invoice = cloneDeep(DEFAULT_DOCUMENT_TEMPLATES_INVOICE_PAYLOAD)
          this.index = index
          this.showDialog = event
        }
      }
    }
  )
}
function renderPanels(h) {
  if (Array.isArray(this.proxy)) {
    if (this.proxy.length) {
      return h(
        'div',
        {
          class: `${services.notifications}-events-balance-limit__panels`
        },
        [
          this.proxy.map((limit, index) => {
            return renderPanel.call(this, h, limit, index)
          })
        ]
      )
    } else {
      return renderEmptyState.call(this, h)
    }
  }
}

function renderAddLimitButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.add'),
        mode: buttonModes.flat,
        size: sizes.small
      },
      on: {
        click: () => {
          this.add()
        }
      }
    }
  )
}
function renderSaveLimitButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.save'),
        mode: buttonModes.flat,
        size: sizes.small,
        color: Colors.primary
      },
      on: {
        click: () => {
          this.$emit('input', this.proxy)
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe grid-gap--8'
    },
    [
      renderAddLimitButton.call(this, h),
      renderSaveLimitButton.call(this, h)
    ]
  )
}

function renderInvoiceDialog(h) {
  if (Array.isArray(this.proxy) && this.proxy.length) {
    if (this.proxy[this.index].invoice) {
      return h(
        invoiceDialog,
        {
          props: {
            value: this.proxy[this.index].invoice,
            show: this.showDialog,
            OwnerId: this.UserId,
            ResellerId: this.ResellerId
          },
          key: this.index,
          on: {
            input: event => {
              this.proxy[this.index].invoice = event
            },
            show: event => {
              this.showDialog = event
            },
            validation: event => {
              if (!event) {
                this.proxy[this.index].invoice = false
              }
            }
          }
        }
      )
    }
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderPanels.call(this, h),
      renderFooter.call(this, h),
      renderInvoiceDialog.call(this, h)
    ]
  )
}
